export default __webpack_public_path__ + "static/blob-07-c3e2974395c55036333d2ea67653bd8a.svg";